// reset before any vue components
import '@/stylesheets/reset.scss'

import Vue from 'vue'
import './plugins/vuetify'
import VueProgressBar from 'vue-progressbar'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'

import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(VueProgressBar, {
  // $color-bleu-de-france in color.scss
  color: '#3D91F7',
  failedColor: 'red',
  height: '3px'
})

Vue.config.productionTip = false

new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
